import { Box, Link, Paper, Stack, Typography } from "@mui/material";

const WelcomeDashboard = ({ children }) =>
{
  return (
    <Box sx={{ px: { xs: 1, sm: 2 }, py: { xs: 1, sm: 2 } }}>
      <Paper
        sx={{
          p: { xs: 3, sm: 4 },
          borderRadius: 3,
          borderColor: "rgba(0,0,0,0.08)",
          maxWidth: 920,
          mx: "auto",
        }}>
        <Stack spacing={3}>
          <Stack spacing={1}>
            <Typography
              variant="h4"
              sx={{
                fontWeight: 700,
                lineHeight: 1.2,
                fontSize: { xs: "1.6rem", sm: "2rem" },
              }}>
              Ola, seja bem-vindo!
            </Typography>
            <Typography
              sx={{
                color: "text.secondary",
                lineHeight: 1.7,
                maxWidth: 760,
                fontSize: { xs: "0.95rem", sm: "1rem" },
              }}>
              Este painel permite administrar o Passaporte da Estrada Real com praticidade.
            </Typography>
          </Stack>

          <Box
            sx={{
              p: { xs: 2, sm: 2.5 },
              borderRadius: 2,
              backgroundColor: "rgba(40,138,121,0.06)",
              border: "1px solid rgba(40,138,121,0.2)",
            }}>
            <Typography sx={{ color: "text.primary", lineHeight: 1.7 }}>
              Em caso de duvidas sobre administracao ou novas funcionalidades, fale com nosso time pelo e-mail{" "}
              <Link
                href="mailto:contato@physis.io?subject=Estrada Real Passaporte Admin: Dúvidas"
                underline="hover"
                sx={{ fontWeight: 600 }}>
                contato@physis.io
              </Link>
              .
            </Typography>
          </Box>

          {children}

          <Typography
            variant="caption"
            sx={{
              color: "text.secondary",
              textAlign: "right",
              display: "block",
              pt: 1,
            }}>
            Versao 1.1.0
          </Typography>
        </Stack>
      </Paper>
    </Box>
  );
};

export default WelcomeDashboard;
